import type { FC, ReactNode } from "react";

import styled from "styled-components";

interface IQueryBarItemProps {
    id: string;
    renderComponent: ReactNode;
    activeItem?: any;
    searchComponent?: ReactNode;
    loadingComponent?: ReactNode;
    className?: string;
    isLoading?: boolean;
}

const ItemContainer = styled.div`
    position: relative;
    min-width: 0;
`;

export const QueryBarItem: FC<IQueryBarItemProps> = ({
    id,
    className,
    activeItem,
    isLoading,
    searchComponent,
    renderComponent,
    loadingComponent,
}) => {
    const classNames = `querybar-item${className ? ` ${className}` : ""}`;
    return (
        <ItemContainer className={classNames}>
            {renderComponent}
            {activeItem !== id
                ? null
                : !isLoading
                  ? searchComponent && searchComponent
                  : loadingComponent && loadingComponent}
        </ItemContainer>
    );
};

QueryBarItem.displayName = "QueryBarItem";
